exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:400,600,400italic,600italic);", ""]);
exports.push([module.id, "@import url(https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css);", ""]);
exports.push([module.id, "@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.6.1/css/font-awesome.min.css);", ""]);
exports.push([module.id, "@import url(https://assets.datacite.org/stylesheets/datacite.css);", ""]);

// module
exports.push([module.id, "", ""]);

// exports
